import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Group, Rect, Circle, Path, Text, Ellipse, Image, Line, Polygon, Polyline, HTML } from '@antv/g';
import { group } from 'd3-array';
import { error } from './helper';
export function select(node) {
  return new Selection([node], null, node, node.ownerDocument);
}
/**
 * A simple implementation of d3-selection for @antv/g.
 * It has the core features of d3-selection and extended ability.
 * Every methods of selection returns new selection if elements
 * are mutated(e.g. append, remove), otherwise return the selection itself(e.g. attr, style).
 * @see https://github.com/d3/d3-selection
 * @see https://github.com/antvis/g
 * @todo Nested selections.
 * @todo More useful functor.
 */
export var Selection = /*#__PURE__*/function () {
  function Selection() {
    var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var document = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var selections = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [null, null, null, null, null];
    var transitions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var updateElements = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    _classCallCheck(this, Selection);
    this._elements = Array.from(elements);
    this._data = data;
    this._parent = parent;
    this._document = document;
    this._enter = selections[0];
    this._update = selections[1];
    this._exit = selections[2];
    this._merge = selections[3];
    this._split = selections[4];
    this._transitions = transitions;
    this._facetElements = updateElements;
  }
  _createClass(Selection, [{
    key: "selectAll",
    value: function selectAll(selector) {
      var elements = typeof selector === 'string' ? this._parent.querySelectorAll(selector) : selector;
      return new Selection(elements, null, this._elements[0], this._document);
    }
  }, {
    key: "selectFacetAll",
    value: function selectFacetAll(selector) {
      var elements = typeof selector === 'string' ? this._parent.querySelectorAll(selector) : selector;
      return new Selection(this._elements, null, this._parent, this._document, undefined, undefined, elements);
    }
    /**
     * @todo Replace with querySelector which has bug now.
     */
  }, {
    key: "select",
    value: function select(selector) {
      var element = typeof selector === 'string' ? this._parent.querySelectorAll(selector)[0] || null : selector;
      return new Selection([element], null, element, this._document);
    }
  }, {
    key: "append",
    value: function append(node) {
      var _this = this;
      var callback = typeof node === 'function' ? node : function () {
        return _this.createElement(node);
      };
      var elements = [];
      if (this._data !== null) {
        // For empty selection, append new element to parent.
        // Each element is bind with datum.
        for (var i = 0; i < this._data.length; i++) {
          var d = this._data[i];
          var _ref = Array.isArray(d) ? d : [d, null],
            _ref2 = _slicedToArray(_ref, 2),
            datum = _ref2[0],
            from = _ref2[1];
          var newElement = callback(datum, i);
          newElement.__data__ = datum;
          if (from !== null) newElement.__fromElements__ = from;
          this._parent.appendChild(newElement);
          elements.push(newElement);
        }
        return new Selection(elements, null, this._parent, this._document);
      } else {
        // For non-empty selection, append new element to
        // selected element and return new selection.
        for (var _i = 0; _i < this._elements.length; _i++) {
          var element = this._elements[_i];
          var _datum = element.__data__;
          var _newElement = callback(_datum, _i);
          element.appendChild(_newElement);
          elements.push(_newElement);
        }
        return new Selection(elements, null, elements[0], this._document);
      }
    }
  }, {
    key: "maybeAppend",
    value: function maybeAppend(id, node, className) {
      var element = this._elements[0];
      var child = element.getElementById(id);
      if (child) {
        return new Selection([child], null, this._parent, this._document);
      }
      var newChild = typeof node === 'string' ? this.createElement(node) : node();
      newChild.id = id;
      if (className) newChild.className = className;
      element.appendChild(newChild);
      return new Selection([newChild], null, this._parent, this._document);
    }
    /**
     * Bind data to elements, and produce three selection:
     * Enter: Selection with empty elements and data to be bind to elements.
     * Update: Selection with elements to be updated.
     * Exit: Selection with elements to be removed.
     */
  }, {
    key: "data",
    value: function data(_data) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
        return d;
      };
      var groupId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return null;
      };
      // An Array of new data.
      var enter = [];
      // An Array of elements to be updated.
      var update = [];
      // A Set of elements to be removed.
      var exit = new Set(this._elements);
      // An Array of data to be merged into one element.
      var merge = [];
      // A Set of elements to be split into multiple datum.
      var split = new Set();
      // A Map from key to each element.
      var keyElement = new Map(this._elements.map(function (d, i) {
        return [id(d.__data__, i), d];
      }));
      // A Map from key to exist element. The Update Selection
      // can get element from this map, this is for diff among
      // facets.
      var keyUpdateElement = new Map(this._facetElements.map(function (d, i) {
        return [id(d.__data__, i), d];
      }));
      // A Map from groupKey to a group of elements.
      var groupKeyElements = group(this._elements, function (d) {
        return groupId(d.__data__);
      });
      // Diff data with selection(elements with data).
      // !!! Note
      // The switch is strictly ordered, not not change the order of them.
      for (var i = 0; i < _data.length; i++) {
        var datum = _data[i];
        var key = id(datum, i);
        var groupKey = groupId(datum, i);
        // Append element to update selection if incoming data has
        // exactly the same key with elements.
        if (keyElement.has(key)) {
          var element = keyElement.get(key);
          element.__data__ = datum;
          element.__facet__ = false;
          update.push(element);
          exit.delete(element);
          keyElement.delete(key);
          // Append element to update selection if incoming data has
          // exactly the same key with updateElements.
        } else if (keyUpdateElement.has(key)) {
          var _element = keyUpdateElement.get(key);
          _element.__data__ = datum;
          // Flag this element should update its parentNode.
          _element.__facet__ = true;
          update.push(_element);
          keyUpdateElement.delete(key);
          // Append datum to merge selection if existed elements has
          // its key as groupKey.
        } else if (groupKeyElements.has(key)) {
          var _group = groupKeyElements.get(key);
          merge.push([datum, _group]);
          var _iterator = _createForOfIteratorHelper(_group),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _element2 = _step.value;
              exit.delete(_element2);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          groupKeyElements.delete(key);
          // Append element to split selection if incoming data has
          // groupKey as its key, and bind to datum for it.
        } else if (keyElement.has(groupKey)) {
          var _element3 = keyElement.get(groupKey);
          if (_element3.__toData__) _element3.__toData__.push(datum);else _element3.__toData__ = [datum];
          split.add(_element3);
          exit.delete(_element3);
        } else {
          // @todo Data with non-unique key.
          enter.push(datum);
        }
      }
      // Create new selection with enter, update and exit.
      var S = [new Selection([], enter, this._parent, this._document), new Selection(update, null, this._parent, this._document), new Selection(exit, null, this._parent, this._document), new Selection([], merge, this._parent, this._document), new Selection(split, null, this._parent, this._document)];
      return new Selection(this._elements, null, this._parent, this._document, S);
    }
  }, {
    key: "merge",
    value: function merge(other) {
      var elements = [].concat(_toConsumableArray(this._elements), _toConsumableArray(other._elements));
      var transitions = [].concat(_toConsumableArray(this._transitions), _toConsumableArray(other._transitions));
      return new Selection(elements, null, this._parent, this._document, undefined, transitions);
    }
  }, {
    key: "createElement",
    value: function createElement(type) {
      if (this._document) {
        return this._document.createElement(type, {});
      }
      var Ctor = Selection.registry[type];
      if (Ctor) return new Ctor();
      return error("Unknown node type: ".concat(type));
    }
    /**
     * Apply callback for each selection(enter, update, exit)
     * and merge them into one selection.
     */
  }, {
    key: "join",
    value: function join() {
      var enter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (d) {
        return d;
      };
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
        return d;
      };
      var exit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (d) {
        return d.remove();
      };
      var merge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (d) {
        return d;
      };
      var split = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (d) {
        return d.remove();
      };
      var newEnter = enter(this._enter);
      var newUpdate = update(this._update);
      var newExit = exit(this._exit);
      var newMerge = merge(this._merge);
      var newSplit = split(this._split);
      return newUpdate.merge(newEnter).merge(newExit).merge(newMerge).merge(newSplit);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _this2 = this;
      var _loop = function _loop(i) {
        var transition = _this2._transitions[i];
        if (transition) {
          var T = Array.isArray(transition) ? transition : [transition];
          Promise.all(T.map(function (d) {
            return d.finished;
          })).then(function () {
            var element = _this2._elements[i];
            element.remove();
          });
        } else {
          var element = _this2._elements[i];
          element.remove();
        }
      };
      // Remove node immediately if there is no transition,
      // otherwise wait until transition finished.
      for (var i = 0; i < this._elements.length; i++) {
        _loop(i);
      }
      return new Selection([], null, this._parent, this._document, undefined, this._transitions);
    }
  }, {
    key: "each",
    value: function each(callback) {
      for (var i = 0; i < this._elements.length; i++) {
        var element = this._elements[i];
        var datum = element.__data__;
        callback(datum, i, element);
      }
      return this;
    }
  }, {
    key: "attr",
    value: function attr(key, value) {
      var callback = typeof value !== 'function' ? function () {
        return value;
      } : value;
      return this.each(function (d, i, element) {
        if (value !== undefined) element[key] = callback(d, i, element);
      });
    }
  }, {
    key: "style",
    value: function style(key, value) {
      var callback = typeof value !== 'function' ? function () {
        return value;
      } : value;
      return this.each(function (d, i, element) {
        if (value !== undefined) element.style[key] = callback(d, i, element);
      });
    }
  }, {
    key: "transition",
    value: function transition(value) {
      var callback = typeof value !== 'function' ? function () {
        return value;
      } : value;
      var T = this._transitions;
      return this.each(function (d, i, element) {
        T[i] = callback(d, i, element);
      });
    }
  }, {
    key: "on",
    value: function on(event, handler) {
      this.each(function (d, i, element) {
        element.addEventListener(event, handler);
      });
      return this;
    }
  }, {
    key: "call",
    value: function call(callback) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      callback.apply(void 0, [this].concat(args));
      return this;
    }
  }, {
    key: "node",
    value: function node() {
      return this._elements[0];
    }
  }, {
    key: "nodes",
    value: function nodes() {
      return this._elements;
    }
  }, {
    key: "transitions",
    value: function transitions() {
      return this._transitions;
    }
  }, {
    key: "parent",
    value: function parent() {
      return this._parent;
    }
  }]);
  return Selection;
}();
Selection.registry = {
  g: Group,
  rect: Rect,
  circle: Circle,
  path: Path,
  text: Text,
  ellipse: Ellipse,
  image: Image,
  line: Line,
  polygon: Polygon,
  polyline: Polyline,
  html: HTML
};